import { Tooltip } from "antd";

const GlobalTooltip = ({
  title,
  children,
  placement = "bottom",
  color = "#959FA3",
}) => {
  return (
    <Tooltip title={title} placement={placement} color={color}>
      {children}
    </Tooltip>
  );
};

export default GlobalTooltip;
